/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfProductFamilyFromDiscriminatorValue, createProductFamilyFromDiscriminatorValue, serializeProductFamily, serializeSaveProductFamilyRequest, type ErrorResponse, type InternalErrorResponse, type PagedResultOfProductFamily, type ProductFamily, type SaveProductFamilyRequest } from '../../models/index.js';
// @ts-ignore
import { type WithFamilyKeyItemRequestBuilder, WithFamilyKeyItemRequestBuilderNavigationMetadata, WithFamilyKeyItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { RefreshSummariesRequestBuilderRequestsMetadata, type RefreshSummariesRequestBuilder } from './refreshSummaries/index.js';
// @ts-ignore
import { type VariantsRequestBuilder, VariantsRequestBuilderNavigationMetadata } from './variants/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/product-families
 */
export interface ProductFamiliesRequestBuilder extends BaseRequestBuilder<ProductFamiliesRequestBuilder> {
    /**
     * The refreshSummaries property
     */
    get refreshSummaries(): RefreshSummariesRequestBuilder;
    /**
     * The variants property
     */
    get variants(): VariantsRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.productFamilies.item collection
     * @param familyKey The family's external key, as it appears in the list and on each variant.
     * @returns {WithFamilyKeyItemRequestBuilder}
     */
     byFamilyKey(familyKey: string) : WithFamilyKeyItemRequestBuilder;
    /**
     * Pages through the organization's product families with each family's summary (price range, variant count, which option values are available, lead image) but not its variants — call GetProductFamily for the grid. An organization that has not enabled product variants gets an empty page, never an error, so a catalog can call this unconditionally.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfProductFamily>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ProductFamiliesRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfProductFamily | undefined>;
    /**
     * Upserts one family by its key. Fields left null keep their stored value, so the family can be enriched in passes: a product import names the family on each row and creates a shell, and a later call adds the copy, option order and images. Variants are not assigned here — send them with the product rows, or with AssignProductFamilyVariants. Rejected when the organization has not enabled product variants.
     * @param body Creates or updates one product family by key. Only the fields sent are changed: a nullOptions, Images or ImagesByOption leaves what isstored, so a source that only knows the family's name and copy cannot erase its images.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ProductFamily>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: SaveProductFamilyRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ProductFamily | undefined>;
    /**
     * Pages through the organization's product families with each family's summary (price range, variant count, which option values are available, lead image) but not its variants — call GetProductFamily for the grid. An organization that has not enabled product variants gets an empty page, never an error, so a catalog can call this unconditionally.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ProductFamiliesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Upserts one family by its key. Fields left null keep their stored value, so the family can be enriched in passes: a product import names the family on each row and creates a shell, and a later call adds the copy, option order and images. Variants are not assigned here — send them with the product rows, or with AssignProductFamilyVariants. Rejected when the organization has not enabled product variants.
     * @param body Creates or updates one product family by key. Only the fields sent are changed: a nullOptions, Images or ImagesByOption leaves what isstored, so a source that only knows the family's name and copy cannot erase its images.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: SaveProductFamilyRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Pages through the organization's product families with each family's summary (price range, variant count, which option values are available, lead image) but not its variants — call GetProductFamily for the grid. An organization that has not enabled product variants gets an empty page, never an error, so a catalog can call this unconditionally.
 */
export interface ProductFamiliesRequestBuilderGetQueryParameters {
    /**
     * Optional filters, the same grammar the product list takes: starts with, contains, notcontains, ends with, equals, not equals on a named field.
     */
    filters?: string[];
    /**
     * The page to return. Default 1.
     */
    pageNumber?: number;
    /**
     * Families per page. Default 25.
     */
    pageSize?: number;
    /**
     * "asc" or "desc". Default "asc".
     */
    sortDirection?: string;
    /**
     * The field to sort on. Default "Name".
     */
    sortOn?: string;
}
/**
 * Uri template for the request builder.
 */
export const ProductFamiliesRequestBuilderUriTemplate = "{+baseurl}/api/product-families?filters={filters}&pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ProductFamiliesRequestBuilderNavigationMetadata: Record<Exclude<keyof ProductFamiliesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byFamilyKey: {
        requestsMetadata: WithFamilyKeyItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithFamilyKeyItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["familyKey"],
    },
    refreshSummaries: {
        requestsMetadata: RefreshSummariesRequestBuilderRequestsMetadata,
    },
    variants: {
        navigationMetadata: VariantsRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ProductFamiliesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ProductFamiliesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfProductFamilyFromDiscriminatorValue,
    },
    put: {
        uriTemplate: ProductFamiliesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createProductFamilyFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSaveProductFamilyRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
